// Necessary if using App Router to ensure this file runs on the client
"use client";

import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { assertEnv } from "@homeinstead/shared";

const applicationId = assertEnv(
  "NEXT_PUBLIC_DD_APP_ID",
  process.env.NEXT_PUBLIC_DD_APP_ID,
);
const clientToken = assertEnv(
  "NEXT_PUBLIC_DD_CLIENT_TOKEN",
  process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
);
const dataDogEnv = assertEnv(
  "NEXT_PUBLIC_DD_ENV",
  process.env.NEXT_PUBLIC_DD_ENV,
);
const service = assertEnv(
  "NEXT_PUBLIC_DD_SERVICE",
  process.env.NEXT_PUBLIC_DD_SERVICE,
);
// VERCEL_GIT_COMMIT_SHA is set by Vercel, If testing locally, set a dummy value in .env.local
// See: https://vercel.com/docs/environment-variables/system-environment-variables#VERCEL_GIT_COMMIT_SHA
const version = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
const site = "datadoghq.com";

datadogLogs.init({
  clientToken,
  env: dataDogEnv,
  // RUM already collects uncaught errors. Keep Logs for explicit log() calls instead of duplicating
  // every client error into the Logs product.
  forwardErrorsToLogs: false,
  service,
  sessionSampleRate: 100,
  site,
  version,
});

datadogRum.init({
  // Specify URLs to propagate trace headers for connection between RUM and backend trace
  allowedTracingUrls: [
    { match: /\/fawkes\/api\//, propagatorTypes: ["tracecontext"] },

    // TODO - it would be great to add these to the marketing APIs on Azure, too,
    // but those aren't connected to DD yet
  ],
  applicationId,
  clientToken,
  defaultPrivacyLevel: "mask-user-input",
  env: dataDogEnv,
  // Keep propagation limited to allowedTracingUrls.propagatorTypes. Datadog 7
  // otherwise adds the baggage header by default.
  propagateTraceBaggage: false,
  service,
  sessionReplaySampleRate: 5,
  sessionSampleRate: 100,
  site,
  trackLongTasks: true,
  trackResources: true,
  trackUserInteractions: true,
  version,
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
